import { Reducer } from "react"

export const betreffs = [
  { value: 'rueckruf',  label: 'Rückrufwunsch' },
  { value: 'termin',    label: 'Terminvereinbarung' },
  { value: 'angebot',   label: 'Angebotsanfrage' },
  { value: 'sonstiges', label: 'Sonstiges' },
] as const

type betreff = typeof betreffs[number]['value'] | ''

type states = 
  | 'new'
  | 'tryed'
  | 'error'
  | 'loading'
  | 'success'

export const initialState = {
  betreff: '' as betreff,
  email: '',
  telefon: '',
  message: '',

  state: 'new' as states,

  dsgvo: false,
}

type initialState = typeof initialState

export type actionTypes =
  | { type: 'CHANGE_INPUT'; payload: { name: string; value: string } }
  | { type: 'CHANGE_STATE'; payload: states }
  | { type: 'DSGVO_TOGGLE'; payload: boolean }
  
const reducer: Reducer<initialState, actionTypes> = (
  state = initialState,
  action: actionTypes
): initialState => {

  const { type, payload } = action

  switch (type) {

    case 'CHANGE_INPUT':
      return {...state,
        [payload.name]: payload.value,
      }

    case 'CHANGE_STATE':
      return {...state,
        state: payload,
      }

    case 'DSGVO_TOGGLE':
      return {...state,
        dsgvo: payload,
      }

    default: throw new Error("unknown 'kontakt' action")
  }
}

export default reducer
